// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";
import * as Classes from "../";

import { Text } from "@blueprintjs/core";

import { MPDIcon, MPDSelectTypes } from "../";

import "./styles.css";

export interface IMPDSelectProps {
  className?: string;
  options?: Array<string>;
  category?: string;
  name?: string;
  icon?: string;
  value?: string;
  selectable?: boolean;
  arrowName?: string;
  type?: MPDSelectTypes;
  label?: string;
  onChange?(event: React.MouseEvent<HTMLElement>, category: string): void;
}

interface IMPDSelectState {
  arrowName?: string;
  currentSelect?: string;
  listOpen: boolean;
  containerWidth?: number;
  optionsWidth?: number;
  selectWidth?: number;
  mouseDown?: boolean;
  posOptionsY?: number;
  type?: MPDSelectTypes;
}

export class MPDSelect extends React.Component<
  IMPDSelectProps,
  IMPDSelectState
> {
  constructor(props: IMPDSelectProps) {
    super(props);
    this.onListClick = this.onListClick.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onToggleList = this.onToggleList.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    const { arrowName, options, value, type } = this.props;
    let currentSelect;

    if (options) {
      currentSelect = value || options[0];
    }

    this.state = {
      currentSelect,
      listOpen: false,
      arrowName: arrowName || "select-arrow",
      type: type || MPDSelectTypes.default
    };
  }

  public componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  public componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  public render() {
    const { className, name, icon, selectable, options, label } = this.props;
    const { arrowName, currentSelect, listOpen, type } = this.state;
    const classes = classNames(Classes.SELECT, className);

    return (
      <div
        className={classNames(
          Classes.SELECT_CONTAINER,
          listOpen && Classes.SHOW,
          Classes.selectStatesClass(type)
        )}
        onClick={this.onToggleList}
        onMouseDown={this.onMouseDown}
        onMouseUp={this.onMouseUp}
      >
        <div className={Classes.SELECT_INNER_CONTAINER}>
          {name !== undefined && (
            <div className={Classes.SELECT_ICON_CONTAINER}>
              <MPDIcon name={name} />
            </div>
          )}
          <div className={classes}>
            <div className={Classes.SELECT_TEXT_CONTAINER}>
              <Text className="label"> {label} </Text>
              {type === MPDSelectTypes.default ? (
                <Text className={Classes.SELECT_TEXT}>{currentSelect}</Text>
              ) : type === MPDSelectTypes.staticIcon ? (
                <div className={Classes.SELECT_STATIC_ICON_CONTAINER}>
                  <MPDIcon name={icon} />
                  <Text className={Classes.SELECT_TEXT}>{currentSelect}</Text>
                </div>
              ) : type === MPDSelectTypes.staticText ? (
                <div className={Classes.SELECT_STATIC_TEXT_CONTAINER}>
                  <Text className={Classes.SELECT_TEXT}>{currentSelect}</Text>
                </div>
              ) : (
                type === MPDSelectTypes.images &&
                options &&
                options.map((option, index) => (
                  <MPDIcon
                    className={classNames(
                      currentSelect === option && Classes.ACTIVE
                    )}
                    key={index}
                    name={option}
                  />
                ))
              )}
            </div>
            <div
              className={classNames(
                Classes.SELECT_OPTIONS,
                listOpen && Classes.SHOW
              )}
            >
              {options &&
                options.map((option, index) => (
                  <li
                    key={index}
                    onClick={this.onListClick}
                    className={classNames(
                      (selectable === undefined || selectable) &&
                        currentSelect === option &&
                        Classes.SELECT
                    )}
                  >
                    {option}
                  </li>
                ))}
            </div>
          </div>
          <div className={Classes.SELECT_ARROW_CONTAINER}>
            <MPDIcon name={arrowName} />
          </div>
        </div>
      </div>
    );
  }

  private onMouseDown() {
    this.setState({ mouseDown: true });
  }

  private onMouseUp() {
    this.setState({ mouseDown: false });
  }

  private handleClickOutside(event: any) {
    const { mouseDown } = this.state;
    if (!mouseDown) {
      this.setState({ listOpen: false });
    }
  }

  private onToggleList() {
    const { listOpen } = this.state;
    this.setState({ listOpen: !listOpen });
  }

  private onListClick(event: React.MouseEvent<HTMLLIElement>) {
    const { selectable, category, onChange } = this.props;
    const text = event.currentTarget.textContent;

    if (text !== this.state.currentSelect && onChange) {
      onChange(event, category || "");
    } else if (!selectable && onChange) {
      onChange(event, category || "");
    }
    this.setState({ currentSelect: text || "" });
  }
}



// WEBPACK FOOTER //
// ./src/mpd-library/select/select.tsx